<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_view') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='viewTypes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseViewType')",
                        v-model='viewType',
                        @select='params.viewType = $event.type'
                    )
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_topics') }}
                .form__field-body
                    cs-multiselect(
                        :options="topics"
                        :show-labels="false"
                        :hide-selected="!isTopicOrImageViewType"
                        :close-on-select="isTopicOrImageViewType"
                        :clear-on-select="isTopicOrImageViewType"
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseTheme')"
                        :multiple="!isTopicOrImageViewType"
                        v-model="selectedGroups"
                        track-by='mode'
                        label='name'
                        :disabled="topics.length === 0"
                        v-validate="'required'"
                        data-vv-value-path="innerValue"
                        data-vv-name="topics"
                    )
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
                .form__field-body
                    cs-multiselect(
                        :options="difficulties"
                        v-model="params.difficult"
                        :placeholder="tableLabel(params.difficult)"
                        :custom-label="tableLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            divider
            slot(name='parameters')
            .help-text
                slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame' :disabled="isSaveButtonDisabled")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import { cloneDeep } from "lodash";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";
    import MemoryGameApi from '../../../api/games/memoryGameApi.js';

    export default {
        props: {
            slug: String,
            courseType: String,
            id: [Number, String],
            usersIds: [Array, String],
            homeworkId: [Number, String],
            gameMode: String,
            gameId: [Number, String],
            generatorGameIndex: Number,
            generatorSettings: Boolean,
            levelAnswerDuration: Number,
        },
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                viewTypes: [
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSetting_topics'),
                        type: 'topic'
                    },
                    {
                        name: this.$i18n.t('trainer.trainer_gameFormSetting_images'),
                        type: 'image'
                    }
                ],
                selectedGroups: [],
                params: null,
                difficulties: [
                    {
                        amountOfRows: 4,
                        amountOfColumns: 3
                    },
                    {
                        amountOfRows: 4,
                        amountOfColumns: 4
                    },
                    {
                        amountOfRows: 4,
                        amountOfColumns: 5
                    },
                    {
                        amountOfRows: 4,
                        amountOfColumns: 6
                    },
                    {
                        amountOfRows: 5,
                        amountOfColumns: 6
                    },
                    {
                        amountOfRows: 6,
                        amountOfColumns: 6
                    }
                ],
                topicGroups: [],
                wordGroups: [],
                imageGroups: []
            }
        },
        mounted () {
            this.getTopics();
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.viewType = this.viewTypes.find(view => view.type === this.params.viewType);
            if (this.params.selectedItems.length) {
                if (this.isTopicOrImageViewType) {
                    this.selectedGroups = {name: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + this.params.selectedItems) , mode: this.params.selectedItems}
                } else {
                    this.selectedGroups = this.params.selectedItems.map(topic => {
                        return {name: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + topic) , mode: topic}
                    });
                }
            }
        },
        updated () {
            this.viewType = this.viewTypes.find(view => view.type === this.params.viewType);
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
            topics () {
                let groups = [];
                switch (this.params.viewType) {
                    case ('topic'):
                        groups = this.topicGroups;
                        break;
                    case ('word'):
                        groups = this.wordGroups;
                        break;
                    case ('image'):
                        groups = this.imageGroups;
                }
                groups = groups.map(topic => {
                    return {name: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + topic) , mode: topic}
                });
                return groups.sort((a, b) => a.name.localeCompare(b.name));
            },
            isSaveButtonDisabled () {
                if (this.isTopicOrImageViewType) {
                    return !this.selectedGroups || (Array.isArray(this.selectedGroups) && !this.selectedGroups.length);
                }
                return !this.selectedGroups.length;
            },
            isTopicOrImageViewType() {
                return this.params.viewType === 'topic' || this.params.viewType === 'image';
            }
        },
        watch: {
            'params.viewType': {
                handler (newVal, oldVal) {
                    if (newVal && oldVal) {
                        newVal !== oldVal && (this.selectedGroups = []);
                    }
                }
            },
            'selectedGroups': {
                handler (val) {
                    if (val) {
                        if (this.isTopicOrImageViewType) {
                            this.params.selectedItems = val.mode;
                        } else {
                            this.params.selectedItems = val.map(topic => topic.mode);
                        }
                    }
                }
            },
        },
        methods: {
            getTopics () {
                MemoryGameApi.getGroups(this.user.locale)
                .then(data => ({topicGroups: this.topicGroups, wordGroups: this.wordGroups, imageGroups: this.imageGroups} = data));
            },
            tableLabel (difficult) {
                return difficult.amountOfRows + ' x ' + difficult.amountOfColumns;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }
    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field-body--inline {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .form__multiselect-container {
        flex: 1 1 auto;
    }

    .form__multiselect-container:not(:last-child) {
        margin-right: 10px;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
    .help-text {
        text-align: center;
    }
</style>

